export const sessionsTypes = {
  LOADING: "LOADING",
  FETCH_SESSIONS: "FETCH_SESSIONS",
};
